import Reflux from "reflux";

import DesignManager from "../managers/DesignManager";
import AppActions from "../actions/AppActions";
import UserActions from "../actions/UserActions";

var DesignSaveStore = Reflux.createStore({
  storeName: 'DesignSaveStore',
  init() {
    this.listenTo(UserActions.saveSite, this.onSaveSite);

    DesignManager.on("statusChange", this._onSaveStatusChange);
    DesignManager.on("error", this._onError);
    this.inSync = DesignManager.inSync;

    this.lastStatusChange = Date.now();
  },

  _onSaveStatusChange(inSync) {
    //going to from not inSync to inSync
    if (this.inSync != inSync) {
      this.lastStatusChange = Date.now();
    }

    this.inSync = inSync;
    this.trigger(this.inSync);
  },

  _onError(error) {
    AppActions.showSaveError(error);
  },

  onSaveSite() {
    DesignManager.saveNow();
  },

  getLastStatusChange() {
    return this.lastStatusChange;
  },

  getState() {
    return this.inSync;
  },

  getInitialState() {
    return this.inSync;
  },
});

export default DesignSaveStore;
